<template>
    <section class="section vraag w100 clearfix">
        <div class="w100">
            <label class="question" :class="[required ? 'required' : '']" for="'textarea-'+name"><h4>{{ label }}</h4></label>
        </div>
        <div class="w100 input" :class="[error ? 'error-textarea' : '']">
            <textarea
                id="'textarea-'+name"
                class="gt-form-textarea"
                :class="[error ? 'error' : '']"
                cols="62"
                rows="5"
                data-placement="bottom"
                @input="$emit('input', $event.target.value)"
                ></textarea>
            <div class="error-icon d-none">
                <span>!</span>
            </div>
            <div class="tooltip bottom">
                <div class="tooltip-arrow"></div>
                <div class="tooltip-inner">{{ error }}</div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        name: String,
        label: String,
        value: String,
        error: String,
        required: Boolean,
    },
}
</script>
